var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import './rules';
import FormValidatorDecorator from './decorator';
import { convertRules } from './utils';
export const FormValidator = (props) => {
    const { children, name, rules } = props, restProps = __rest(props, ["children", "name", "rules"]);
    return (React.createElement(FormValidatorDecorator, Object.assign({ name: name }, restProps, convertRules(rules)), React.Children.only(children) && React.isValidElement(children) && React.cloneElement(children)));
};
export default FormValidator;
